import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import  Box  from "@material-ui/core/Box";
import LoginButton from "../../Login/loginButton";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { WebContext } from "../../../../Utility";
import Search from "../../navbarSearch";
import SocialMediaLinks from "../../Commons/SocialMediaLinks";
import { NAVBAR_EXTERNAL_LINKS } from "../../../../Constants";
import { DesktopMenuDropdown } from "../mobileNavbar";
const useStyles = makeStyles((theme) => ({
  navbar: {
    height: 100,
    width: "100%",
    zIndex: 1,
   background: "transparent !important",
  },
  navLink: {
    whiteSpace: "nowrap",
  },
  navLinkSub: {
    color: "white",
  },
  nonTransparentNavLink: {
    color: theme.agentTheme.primary.foreground,
  },
  transparentNavLink: {
    color: "white",
  },
  navBarContainer: {
    display: "flex",
    height: "inherit",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
  navBarLogo: {
    margin: "auto 0px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& img": {
      width: "100%",
      objectFit: "contain",
    },
    webkitBackdropFilter: "blur(0px)",
    backdropFilter: "blur(0px)",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
  },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
  },
  navBarText: {
    padding: "0px 5px",
    display: "flex",
    justifyContent: "center",
    color: theme.agentTheme.card.link_foreground,
    alignItems: "center",
    "&:hover": {
      color: `${theme.agentTheme.primary.main} !important`,
    },
    "&$activeNavItem": {
      color: `${theme.agentTheme.primary.main} !important`,
    },
  },
  navBarTextContainer: {
    marginRight: 20,
    cursor: "pointer",
    display: "flex",
    alignItems: "flex-end",
    paddingBottom: 10,
    height: "100%",
  },
  navIcon: {
    margin: "auto 0px",
    color: theme.agentTheme.primary.main,
    zIndex: 1,
    webkitBackdropFilter: "blur(0px)",
    backdropFilter: "blur(0px)",
  },
  navIconNonTransparent: {
    color: theme.agentTheme.primary.main,
  },
  menuDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "rgba(0, 0, 0, 0.9)",
    height: "100vh",
    justifyContent: "space-evenly",
    padding: "100px 0px",
    paddingBottom: "80px",
    position: "absolute",
    width: "100vw",
    left: 0,
    color: "white",
    position: "fixed",
    top: 0,
    bottom: 0,
    zIndex: 99,
  },
  navTextHover: {
    transition: "all 0.3s ease",
    borderBottom: `4px solid transparent`,
    "&:hover": {
      borderBottom: `4px solid ${theme.agentTheme.primary.main}`,
    },
    "&$activeNavItem": {
      borderBottom: `4px solid ${theme.agentTheme.primary.main}`,
    },
  },
  navTextHoverNonTransparent: {
    transition: "all 0.3s ease",
    borderBottom: `4px solid transparent`,
    "&:hover": {
      borderBottom: `4px solid ${theme.agentTheme.primary.foreground}`,
      color: theme.agentTheme.primary.foreground,
    },
    "&$activeNavItem": {
      borderBottom: `4px solid ${theme.agentTheme.secondary.main}`,
      color: theme.agentTheme.secondary.main,
    },
  },
  activeNavItem: {
    color: theme.agentTheme.secondary.main,
  },
  searchDiv: {
    margin: "auto 8px",
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
  },
  activeMobileItem: {
    color: theme.agentTheme.primary.main,
  },
  inActiveMobileItem: {
    color: theme.agentTheme.primary.foreground,
  },
  navbarColorNonTransparent: {
    backgroundColor: "transparent",
  },
  navbarTransparentBg: {
    background: "transparent",
  },
  socialMediaContainer: {
    width: "25%",
  },
  loginButtonTransparent: {
    color: theme.agentTheme.primary.main,
    borderColor: theme.agentTheme.primary.main,
    marginTop: "10px",
    height: "35px",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  loginButtonNonTransparent: {
    color: theme.agentTheme.secondary.main,
    borderColor: theme.agentTheme.secondary.main,
    marginTop: "10px",
    height: "35px",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));

export default (props) => {
  let {
    logo_url = "",
    contentArr = [],
    username = "",
    getLogoUrl,
    isMobile = false,
    toggleMenu: mobileNavBarOpen = false,
    memberProfile,
    onNavIconClick,
    nonTransparentNav = false,
    handleCovidMenuClose,
    handleCovidMenuItemClick,
    loginItem,
  } = props || {};
  const { social_media_links = [] } = memberProfile;
  const classes = useStyles();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
  const { website_modules: websiteModules = {} } = memberProfile || {};
  const { packages: isPackagesEnabled = true } = websiteModules || {};
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clickItem, setClickItem] = useState([]);
  const handleCovidMenuClick = (
    event,
    clickItemParam = [],
    islogin = false
  ) => {
    setIsLoginMenu(islogin);
    if (clickItemParam.length > 0) setClickItem(clickItemParam);
    if (anchorEl == null) setAnchorEl(event.currentTarget);
    else handleCovidMenuClose();
  };
  const getNavItem = () => {
    return (
      <>
        {contentArr.map((item) => {
          let showActive = false;
          if (location.pathname == item.link) showActive = true;
          else if (location.pathname == "/" && item.link == `/${username}`)
            showActive = true;
          else if (item.clickHandle) {
            item.clickItem.map((element) => {
              if (
                element.link == location.pathname ||
                element.link.pathname == location.pathname
              )
                showActive = true;
            });
          }
          if (mobileNavBarOpen) {
          } else {
            if (item.clickHandle) {
              return (
                <>
                  <div
                    className={`${
                      nonTransparentNav
                        ? classes.nonTransparentNavLink
                        : classes.transparentNavLink
                    }  ${classes.navLink}`}
                    onClick={(e) => handleCovidMenuClick(e, item.clickItem)}
                  >
                    <div
                      className={`${
                        nonTransparentNav
                          ? classes.navTextHoverNonTransparent
                          : classes.navTextHover
                      } ${classes.navBarTextContainer} ${
                        showActive && classes.activeNavItem
                      }`}
                    >
                      <Typography
                        variant="h6"
                        noWrap={true}
                        className={classes.navBarText}
                      >
                        {item.label} {item.dropdown && <KeyboardArrowDown />}
                      </Typography>
                    </div>
                  </div>
                </>
              );
            } else {
              const isExternalLink = NAVBAR_EXTERNAL_LINKS.includes(
                item.label.toLowerCase()
              );
              return isExternalLink ? (
                <a
                  href={item.link}
                  className={`${classes.navLink} ${
                    nonTransparentNav
                      ? classes.nonTransparentNavLink
                      : classes.transparentNavLink
                  }`}
                >
                  <div
                    className={`${
                      nonTransparentNav
                        ? classes.navTextHoverNonTransparent
                        : classes.navTextHover
                    } ${classes.navBarTextContainer} ${
                      showActive && classes.activeNavItem
                    }`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </a>
              ) : (
                <NavLink
                  to={{
                    pathname: item.link,
                    hash: item.hash || "",
                    state: { memberProfileData: memberProfile },
                  }}
                  className={`${classes.navLink} ${
                    nonTransparentNav
                      ? classes.nonTransparentNavLink
                      : classes.transparentNavLink
                  }`}
                >
                  <div
                    className={`${
                      nonTransparentNav
                        ? classes.navTextHoverNonTransparent
                        : classes.navTextHover
                    } ${classes.navBarTextContainer} ${
                      showActive && classes.activeNavItem
                    }`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </NavLink>
              );
            }
          }
        })}
      </>
    );
  };
  return (
    <div
      className={`${classes.navbar} ${
        nonTransparentNav
          ? classes.navbarColorNonTransparent
          : classes.navbarTransparentBg
      }`}
    >
      <Container maxWidth={false} className={classes.navBarContainer}>
        <div className={classes.navBarLogo}>
          {!isMobile && (
            <div className={classes.socialMediaContainer}>
              <SocialMediaLinks social_media_links={social_media_links} />
            </div>
          )}
          {!isMobile && logo_url && (
            <Link to={`/${username ? `${username}` : ""}`}>
              <img src={getLogoUrl(logo_url)} height="50" />
            </Link>
          )}
          {isMobile && (
            <div
              className={`${classes.navIcon} ${
                !mobileNavBarOpen &&
                nonTransparentNav &&
                classes.navIconNonTransparent
              }`}
            >
              {!mobileNavBarOpen ? (
                <MenuIcon onClick={onNavIconClick} />
              ) : (
                <CloseIcon onClick={onNavIconClick} />
              )}
            </div>
          )}
          {!isMobile && (
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              width={"100%"}
            >
              {isPackagesEnabled && (
                <div className={classes.searchDiv}>
                  <Search
                    type="NAVBAR_SEARCH_3"
                    nonTransparentNav={nonTransparentNav}
                  />
                </div>
              )}
              <Box
                onClick={(e) => isLoggedIn && handleCovidMenuClick(e, [], true)}
              >
                <LoginButton
                  loginClass={
                    nonTransparentNav
                      ? classes.loginButtonNonTransparent
                      : classes.loginButtonTransparent
                  }
                />
              </Box>
            </Box>
          )}
        </div>
        {isMobile && logo_url && (
          <Link to={`/${username ? `${username}` : ""}`}>
            <img src={getLogoUrl(logo_url)} height="50" />
          </Link>
        )}
        {!isMobile && (
          <div className={classes.navBarContent}>{getNavItem()}</div>
        )}
        {isMobile && (
          <LoginButton
            loginClass={
              nonTransparentNav
                ? classes.loginButtonNonTransparent
                : classes.loginButtonTransparent
            }
          />
        )}
      </Container>
      {(isLoginMenu || clickItem.length > 0) && (
        <DesktopMenuDropdown
          anchorEl={anchorEl}
          handleCovidMenuClose={handleCovidMenuClose}
          loginMenu={isLoginMenu}
          clickItem={isLoginMenu ? loginItem : clickItem}
          handleCovidMenuItemClick={handleCovidMenuItemClick}
        />
      )}
    </div>
  );
};
